module.exports = __webpack_public_path__ + "static/media/ic-good-work.086c9a62.svg";